import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

export function showToast(message, type = 'success') {
    const colors = {
        success: '#36D399',  // DaisyUI success color
        error: '#F87272',    // DaisyUI error color
        info: '#3ABFF8',     // DaisyUI info color
        warning: '#FBBD23'   // DaisyUI warning color
    };

    Toastify({
        text: message,
        duration: 3000,
        gravity: 'top',
        position: 'right',
        style: {
            background: colors[type] || colors.info,
            borderRadius: '0.5rem',
            padding: '1rem',
            fontSize: '0.875rem'
        }
    }).showToast();
}
